export enum ChartType {
  SINGLE,
  GAUGE,
  LINE,
  BARSV,
  BARSH,
}